import React, { useState } from "react";
import { Container, TabContent, TabPane } from "reactstrap";
import Location from "./Location";
import General from "./General";
import "../Standards/Standards.scss";
import "./Settings.scss";

const tabs = [
  { id: 1, label: "General", icon: "bx-cog" },
  { id: 4, label: "Locations", icon: "bx-map" },
];

const SettingsMeetings = () => {
  const [activeTab, setActiveTab] = useState(1);

  return (
    <div className="page-content settings-page piers-page">
      <Container fluid>
        <header className="standards-page__header settings-page__header piers-page-header">
          <div>
            <h1 className="piers-page-title">Settings</h1>
            <p>
              Manage your firm profile, operational locations, and account
              configuration.
            </p>
          </div>
        </header>
        <nav
          className="settings-page__tabs"
          aria-label="Firm settings sections"
        >
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={activeTab === tab.id ? "is-active" : ""}
              onClick={() => setActiveTab(tab.id)}
            >
              <i className={`bx ${tab.icon}`} />
              {tab.label}
            </button>
          ))}
        </nav>
        <TabContent
          activeTab={activeTab}
          className="settings-page__tabs-content"
        >
          <TabPane tabId={1}>
            <General />
          </TabPane>
          <TabPane tabId={4}>
            <Location />
          </TabPane>
        </TabContent>
      </Container>
    </div>
  );
};

export default SettingsMeetings;
